export enum BrandTypeEnum {
	Part = 1,
	Tire = 2,
}
